import data from "../../../../../src/deprecated/FilteredSearch/FilteredSearch.docs.json";
import * as React from 'react';
export default {
  data,
  React
};